import template from './ContactFormSimpleField.html';

export default {
  name: 'ContactFormSimpleField',

  template,

  props: {
    initContent: {
      type: Object,
      required: true,
    },
    uniqueId: String,
  },

  data() {
    return {
      content: this.initContent,
    };
  },

  created() {
    this.validateContent(this.initContent);
  },

  // Methods

  methods: {
    validateContent(content) {
      if (
        typeof content.contact_form_simple.title === 'undefined' ||
        typeof content.contact_form_simple.mailTo === 'undefined'
      ) {
        throw new Error('Invalid content given to ContactFormSimpleField');
      }

      return true;
    },

  },
};
